import { DownloadFormat } from '../enums/downloadFormat'

export const DownloadFormatToMimeType: Record<DownloadFormat, string> = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
}
